import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetNewTitleBucketsQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	newTitlesFilter?: Types.InputMaybe<Types.TitleFilter>;
	newAfterCursor?: Types.InputMaybe<Types.Scalars['String']['input']>;
	first?: Types.Scalars['Int']['input'];
	priceDrops: Types.Scalars['Boolean']['input'];
	bucketSize?: Types.Scalars['Int']['input'];
	groupBy?: Types.NewTitleAggregation;
	pageType?: Types.NewPageType;
}>;

export type GetNewTitleBucketsQuery = {
	__typename?: 'Query';
	newTitleBuckets: {
		__typename?: 'NewTitleBucketsConnection';
		pageInfo: {
			__typename?: 'PageInfo';
			startCursor: string;
			endCursor: string;
			hasPreviousPage: boolean;
			hasNextPage: boolean;
		};
		edges?: Array<{
			__typename?: 'NewTitleBucketsEdge';
			key:
				| { __typename?: 'BucketAggregationKey' }
				| {
						__typename?: 'BucketPackageAggregationKey';
						bucketType: Types.NewDateRangeBucket;
						package: { __typename?: 'Package'; id: string; packageId: number; shortName: string };
				  }
				| { __typename?: 'DateAggregationKey' }
				| {
						__typename?: 'DatePackageAggregationKey';
						date: any;
						package: { __typename?: 'Package'; id: string; packageId: number; shortName: string };
				  };
			node: {
				__typename?: 'NewTitlesConnection';
				totalCount: number;
				pageInfo: {
					__typename?: 'PageInfo';
					endCursor: string;
					hasNextPage: boolean;
					hasPreviousPage: boolean;
				};
			};
		}> | null;
	};
};

export const GetNewTitleBucketsDocument = gql`
	query GetNewTitleBuckets(
		$country: Country!
		$newTitlesFilter: TitleFilter
		$newAfterCursor: String
		$first: Int! = 2
		$priceDrops: Boolean!
		$bucketSize: Int! = 8
		$groupBy: NewTitleAggregation! = DATE_PACKAGE
		$pageType: NewPageType! = NEW
	) {
		newTitleBuckets(
			country: $country
			filter: $newTitlesFilter
			after: $newAfterCursor
			first: $first
			bucketSize: $bucketSize
			priceDrops: $priceDrops
			pageType: $pageType
			groupBy: $groupBy
		) {
			pageInfo {
				startCursor
				endCursor
				hasPreviousPage
				hasNextPage
			}
			edges {
				key {
					... on DatePackageAggregationKey {
						date
						package {
							id
							packageId
							shortName
						}
					}
					... on BucketPackageAggregationKey {
						bucketType
						package {
							id
							packageId
							shortName
						}
					}
				}
				node {
					totalCount
					pageInfo {
						endCursor
						hasNextPage
						hasPreviousPage
					}
				}
			}
		}
	}
`;
